/** Where the brand hub pages live, for every link and redirect to agree on. */

export const brandPath = (slug: string) => `/brand-hub/brand/${encodeURIComponent(slug)}`;

export const brandTabPath = (slug: string, tab: string) => `${brandPath(slug)}/${tab}`;

export const productImportPath = (slug: string) => `${brandTabPath(slug, 'products')}/import`;

/** The history of every import. Naming one opens it on that record. */
export const productImportsPath = (slug: string, importId?: string) =>
  `${brandTabPath(slug, 'products')}/imports${importId ? `?import=${encodeURIComponent(importId)}` : ''}`;

export const TEMPLATES_PATH = '/brand-hub/templates';

export const TEMPLATE_CREATE_PATH = `${TEMPLATES_PATH}/new`;

export const templatePath = (templateId: string) => `${TEMPLATES_PATH}/${encodeURIComponent(templateId)}`;
